import {
    entityValidator,
    idValidators,
    latitudeValidators,
    longitudeValidators,
    UnionToTuple,
} from "../util"
import { IconImage } from "@nova/protobuf"

export const createIconImageValidator = entityValidator(IconImage, {
    id: { validators: idValidators, nonNull: true },
    index: { validators: [], nonNull: true },
    fileName: { validators: [], nonNull: true },
    size: { validators: [], nonNull: true },
    longitude: { validators: longitudeValidators },
    latitude: { validators: latitudeValidators },
    altitude: { validators: [] },
    takenAt: { validators: [] },
    focalLength: { validators: [] },
    make: { validators: [] },
    imageWidth: { validators: [] },
    imageHeight: { validators: [] },
    hasThumbnail: { validators: [] },
})

export const updateIconImageValidator = entityValidator(IconImage, {})

export const getDefaultIconImageCreateArgs = () => ({})

export type CreateIconImageArgs = UnionToTuple<keyof typeof createIconImageValidator>
export type UpdateIconImageArgs = UnionToTuple<keyof typeof updateIconImageValidator>
